import React from 'react';
import { componentTypes, MenuRadio } from '@white-nl/instantsearch-components';
import { useInstantSearch, useMenu, useStats } from 'react-instantsearch';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import Sidebar from '../../../../components/Sidebar/Sidebar';
import { ChevronDown, Filter } from '../../../../components/ui/Icons';

function BlogFilters({
  additionalData,
}: componentTypes.CustomContainerProps) {
  const { results } = useInstantSearch();
  const menu = useMenu({
    attribute: 'blogType',
    sortBy: ['name:asc'],
    limit: 10,
  });

  return (
    <MenuRadio
      results={results}
      menu={menu}
      menuSettings={{
        attribute: 'blogType',
        sortBy: ['name:asc'],
        limit: 10,
        classNames: {
          list: 'flex flex-wrap gap-y-2.5',
          item: 'w-full relative flex items-center min-h-7.5 cursor-pointer text-base leading-normal pl-10.5',
          label: 'underline underline-offset-2 decoration-transparent hover:decoration-light-grey-2 transition-all after:transition-all after:w-7.5 after:h-7.5 after:rounded-full after:border-2 after:border-light-grey-1.5 hover:after:border-dark-shade after:bg-white after:absolute after:top-2/4 after:-translate-y-2/4 after:left-0 before:absolute before:w-4.7 before:h-4.7 before:absolute before:top-2/4 before:-translate-y-2/4 before:left-1.5 before:bg-near-black before:z-10 before:rounded-full before:opacity-0 peer-checked:before:opacity-100',
          radio: 'peer absolute opacity-0 invisible',
          count: 'hidden',
        },
      }}
      additionalData={additionalData}
    />
  );
}

export default function FilterSidebar({
  additionalData,
}: componentTypes.CustomContainerProps) {
  const { nbHits } = useStats();

  const { blogs } = additionalData;

  return (
    <Sidebar
      sidebarButtonContent={(
        <>
          {Craft.t(blogs, 'Filters')}
          <Filter />
        </>
      )}
      sidebarTitle={Craft.t(blogs, 'Filteren')}
      sidebarPanelContent={(
        <Disclosure
          key="blogType"
          as="div"
          className="mb-4 last:mb-0"
          defaultOpen
        >
          <DisclosureButton className="group/open-close w-full justify-between font-semibold text-lg flex items-center gap-x-2.5 text-left py-3 border-b border-light-grey-1 transition-colors hover:text-light-grey-3">
            {Craft.t(blogs, 'Type')}
            <ChevronDown className="block w-auto h-2.5 transition-all mr-2 group-data-[open]/open-close:rotate-180" />
          </DisclosureButton>
          <DisclosurePanel className="py-4 md:py-6">
            <BlogFilters additionalData={additionalData} />
          </DisclosurePanel>
        </Disclosure>
      )}
      closeButtonText={Craft.t(blogs, 'Toon {qty} resultaten', {
        qty: nbHits,
      })}
    />
  );
}
